import _ from 'lodash';
import initialState from './initialstate';

/**
 * apponlinestatereducer.js
 * Created by calhosh on 8/27/2020.
 */
export default function AppOnlineStateReducer(state = initialState.apponlinestate, action) {
	switch (action.type) {
		case 'UPDATE_APP_ONLINE_STATE':
			/* Notice that this is simply returning the action payload, <%=names.camel%>.
			 * This is because the combineReducers() call wraps this reducer
			 * and passes it only the portion of the store state that it
			 * is concerned with. */
			console.log(`[${action.type}]: appOnlineState reducer -`, action);
			if (_.isBoolean(action.isOnline)) {
				return action.isOnline;
			}
			return action.response.isOnline;
		default:
			return state;
	}
}
